import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';
import { mediaBelow, pxToRem, pxToRemMd } from '../../../assets/styles/helper';
import { variables } from '../../../assets/styles/variables';
import themeColors from '../../../assets/styles/themeColors';

const shrink = keyframes`
  from { transform: scaleX(1); }
  to   { transform: scaleX(0); }
`;

const Track = styled.div`
  height: ${pxToRem(2)};
  width: calc(100% + ${pxToRem(32)});
  margin: -${pxToRem(18)} -${pxToRem(16)} ${pxToRem(18)};
  background: ${themeColors.colorBackgroundSecondary};
  overflow: hidden;

  ${mediaBelow(variables.breakpoints.bpMd)} {
    width: calc(100% + ${pxToRemMd(48)});
    margin: -${pxToRemMd(24)} -${pxToRemMd(24)} ${pxToRemMd(24)};
  }
`;

const Fill = styled.div`
  height: 100%;
  width: 100%;
  background: ${themeColors.colorPrimary};
  transform-origin: left;
  animation: ${shrink} ${({ $durationMs }) => `${$durationMs}ms`} linear
    infinite;
  animation-play-state: ${({ $paused }) => ($paused ? 'paused' : 'running')};
`;

const SellFromHomePriceRefreshBar = ({ durationMs, paused }) => (
  <Track data-cy="bar-sfh-price-refresh">
    <Fill $durationMs={durationMs} $paused={paused} />
  </Track>
);

SellFromHomePriceRefreshBar.propTypes = {
  durationMs: PropTypes.number,
  paused: PropTypes.bool,
};

SellFromHomePriceRefreshBar.defaultProps = {
  durationMs: 30_000,
  paused: false,
};

export default SellFromHomePriceRefreshBar;
